import { Box, Flex, HStack, VStack, Link, Menu, MenuButton, MenuList, MenuItem, Button, Image, Heading, Text, IconButton, Drawer, DrawerBody, DrawerHeader, DrawerOverlay, DrawerContent, DrawerCloseButton, useDisclosure, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon } from "@chakra-ui/react";
import { ChevronDownIcon, HamburgerIcon } from "@chakra-ui/icons";
import { useState, useEffect } from "react";

export default function Header() {
  const [hoveredMenu, setHoveredMenu] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();

  
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  const handleClick = (anchor) => () => {
    const id = `${anchor}-section`;
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };
  
   return ( 
 
    <Box position="fixed" zIndex={isOpen ? "999" : "1000"} px={8} py={4} 
          boxShadow={isScrolled ? "sm" : "none"}
          top={0}
          left={0}
          right={0}
          backgroundColor="rgba(255, 255, 255, 0.9)" 
          transition="background-color 0.3s ease, box-shadow 0.3s ease"
          pointerEvents={isOpen ? "none" : "auto"}
    >
  
        
          <Flex justify="space-between" align="center" maxW="1400px" mx="auto" pointerEvents="auto"> 
            
             {/* LEFT — LOGO + NAME */} 
              <Link href="/" _hover={{ textDecoration: "none" }}>
                <HStack paddingBottom="4px" spacing={3} cursor="pointer">
                    <Image 
                      src={require('../images/logo1.png')} 
                      alt="Swiftchange Logo" 
                      height="60px" 
                      width="60px" 
                      objectFit="cover"
                      borderRadius="md"
                    />
                    <Heading fontSize="1.3rem"> Swiftchang </Heading>
                </HStack>
              </Link> 
                         
            {/* RIGHT — NAVIGATION */} 
            <HStack spacing={8} display={{ base: "none", md: "flex" }}> 
              
              {/* PRODUCTS DROPDOWN */} 
              <Menu isLazy isOpen={hoveredMenu === 'products'}> 
                <MenuButton 
                
                  as={Button} 
                  variant="ghost" 
                  rightIcon={<ChevronDownIcon />} 
                  _hover={{ textDecoration: "none" }}
                  _active={{ textDecoration: "none" }}
                  _focus={{ boxShadow: "none" }}
                  sx={{
                    position: "relative",
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      bottom: "0",
                      left: "50%",
                      transform: "translateX(-50%) scaleX(0)",
                      width: "100%",
                      height: "2px",
                      backgroundColor: "currentColor",
                      transition: "transform 0.3s ease",
                    },
                    "&:hover::after": {
                      transform: "translateX(-50%) scaleX(1)",
                    },
                  }}
                  onMouseEnter={() => setHoveredMenu('products')}
                  onMouseLeave={() => setHoveredMenu(null)}
                > 
                  Products 
                </MenuButton> 
                <MenuList marginTop={-4} height={150}  marginLeft= "-800" bg="transparent" 
                  border="none" zIndex="900" display="flex" 
                  flexDirection="row" justifyContent="space-between" 
                  onMouseEnter={() => setHoveredMenu('products')}
                  onMouseLeave={() => setHoveredMenu(null)}
                > 
                  <MenuItem paddingLeft="400" py={2} minW="auto" 
                    _focus={{ boxShadow: "none"}} 
                    _hover={{ textDecoration: "none", color: "blue.600" }}
                    _active={{ bg: "white" }}
                    as={Link} href="/money-transfer">

                    <VStack align="flex-start" spacing={1} maxW="250px">
                      <Text fontWeight="medium">International Transfers</Text>
                      <Text fontSize="xs" color="gray.600" whiteSpace="normal">Send money accross border at zero fees & competitive exchange rates</Text>
                    </VStack>
                  </MenuItem> 
                  <MenuItem marginLeft= "-70" py={2} minW="auto" _focus={{ boxShadow: "none" }} _hover={{ textDecoration: "none", color: "blue.600" }} _active={{ bg: "white" }} as={Link} href="/money-transfer#multi-currency">
                    <VStack align="flex-start" spacing={1} maxW="250px">
                      <Text fontWeight="medium">Multi-currency Wallet</Text>
                      <Text fontSize="xs" color="gray.600" whiteSpace="normal">Hold and manage multiple currencies including CAD, USD, NGN, & GBP </Text>
                    </VStack>
                  </MenuItem> 
                  <MenuItem marginLeft= "-450" py={2} minW="auto" _focus={{ boxShadow: "none" }} _hover={{ textDecoration: "none", color: "blue.600" }} _active={{ bg: "white" }} as={Link} href="/money-transfer#currency-swap">
                    <VStack align="flex-start" spacing={1} maxW="250px">
                      <Text fontWeight="medium">Currency Swap</Text>
                      <Text fontSize="xs" color="gray.600" whiteSpace="normal">Exchange currencies instantly at competitive exchange rates</Text>
                    </VStack>
                  </MenuItem> 
                </MenuList> 
              </Menu> 
              
              {/* COMPANY DROPDOWN */} 
              <Menu isLazy isOpen={hoveredMenu === 'company'}> 
                <MenuButton 
                  as={Button} 
                  variant="ghost" 
                  rightIcon={<ChevronDownIcon />} 
                  _hover={{ bg: "transparent", textDecoration: "none" }}
                  _active={{ bg: "transparent", textDecoration: "none" }}
                  _focus={{ boxShadow: "none" }}
                  sx={{
                    position: "relative",
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      bottom: "0",
                      left: "50%",
                      transform: "translateX(-50%) scaleX(0)",
                      width: "100%",
                      height: "2px",
                      backgroundColor: "currentColor",
                      transition: "transform 0.3s ease",
                    },
                    "&:hover::after": {
                      transform: "translateX(-50%) scaleX(1)",
                    },
                  }}
                  onMouseEnter={() => setHoveredMenu('company')}
                  onMouseLeave={() => setHoveredMenu(null)}
                > 
                  Company 
                </MenuButton> 
                <MenuList marginTop={-4} height={150} marginLeft="-1000" bg="transparent" border="none" zIndex="900" display="flex" flexDirection="row" justifyContent="space-between" onMouseEnter={() => setHoveredMenu('company')} onMouseLeave={() => setHoveredMenu(null)}> 
                  <MenuItem paddingLeft="340" py={2}  _focus={{ boxShadow: "none" }} _hover={{ textDecoration: "none", color: "blue.600" }} _active={{ bg: "white" }} as={Link} href="/about">
                    <VStack align="flex-start" spacing={1} maxW="260px">
                      <Text fontWeight="medium">About SwiftChang</Text>
                      <Text fontSize="xs" color="gray.600" whiteSpace="normal">Learn about our vision & mission to revolutionize cross-border payments & transfers</Text>
                    </VStack>
                  </MenuItem> 
                  <MenuItem marginLeft="-80" py={2} minW="auto" _focus={{ boxShadow: "none" }} _hover={{ textDecoration: "none", color: "blue.600" }} _active={{ bg: "white" }} as={Link} href="/promotions">
                    <VStack align="flex-start" spacing={1} maxW="250px">
                      <Text fontWeight="medium">Promotions</Text>
                      <Text fontSize="xs" color="gray.600" whiteSpace="normal">Current offers and deals</Text>
                    </VStack>
                  </MenuItem> 
                  <MenuItem marginLeft="-700" py={2} minW="auto" _focus={{ boxShadow: "none" }} _hover={{ textDecoration: "none", color: "blue.600" }} _active={{ bg: "white" }} as={Link} href="/community">
                    <VStack align="flex-start" spacing={1} maxW="250px">
                      <Text fontWeight="medium">Refer and Earn</Text>
                      <Text fontSize="xs" color="gray.600" whiteSpace="normal">Invite friends and earn rewards for every successful referral</Text>
                    </VStack>
                  </MenuItem> 
                   <MenuItem marginLeft="-700" py={2} minW="auto" _focus={{ boxShadow: "none" }} _hover={{ textDecoration: "none", color: "blue.600" }} _active={{ bg: "white" }} as={Link} href="/influencer">
                    <VStack align="flex-start" spacing={1} maxW="250px">
                      <Text fontWeight="medium">Become our Influencer</Text>
                      <Text fontSize="xs" color="gray.600" whiteSpace="normal">Partner with us to grow and earn as a Swiftchang ambassador</Text>
                    </VStack>
                  </MenuItem> 
                
                  {/*<MenuItem marginLeft="-650" py={2} minW="auto" _focus={{ boxShadow: "none" }} _hover={{ textDecoration: "none", color: "blue.600" }} as={Link} href="#">
                    <VStack align="flex-start" spacing={1} maxW="250px">
                      <Text fontWeight="medium">Careers</Text>
                      <Text fontSize="xs" color="gray.600" whiteSpace="normal">Join our growing team</Text>
                    </VStack>
                  </MenuItem> */}
                </MenuList> 
              </Menu> 
              
              {/* COMMUNITY DROPDOWN */} 
              <Menu isLazy isOpen={hoveredMenu === 'community'}> 
                <MenuButton 
                  as={Button} 
                  variant="ghost" 
                  rightIcon={<ChevronDownIcon />} 
                  _hover={{ bg: "transparent", textDecoration: "none" }}
                  _active={{ bg: "transparent", textDecoration: "none" }}
                  _focus={{ boxShadow: "none" }}
                  sx={{
                    position: "relative",
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      bottom: "0",
                      left: "50%",
                      transform: "translateX(-50%) scaleX(0)",
                      width: "100%",
                      height: "2px",
                      backgroundColor: "currentColor",
                      transition: "transform 0.3s ease",
                    },
                    "&:hover::after": {
                      transform: "translateX(-50%) scaleX(1)",
                    },
                  }}
                  onMouseEnter={() => setHoveredMenu('community')}
                  onMouseLeave={() => setHoveredMenu(null)}
                > 
                  Resources 
                </MenuButton> 
                <MenuList marginTop={-4} height={150}  marginLeft="-1100" bg="transparent" border="none" zIndex="900" display="flex" flexDirection="row" justifyContent="space-between" onMouseEnter={() => setHoveredMenu('community')} onMouseLeave={() => setHoveredMenu(null)}> 
                  <MenuItem paddingLeft="500" py={2} minW="auto" _focus={{ boxShadow: "none" }} 
                  _hover={{ textDecoration: "none", color: "blue.600" }} _active={{ bg: "white" }} as={Link} href="/blog">
                    <VStack align="flex-start" spacing={1} maxW="250px">
                      <Text fontWeight="medium">Blog</Text>
                      <Text fontSize="xs" color="gray.600" whiteSpace="normal">Insights, news, and updates from Swiftchang</Text>
                    </VStack>
                  </MenuItem> 
                  <MenuItem marginLeft="-200" py={2} minW="auto" _focus={{ boxShadow: "none" }} _hover={{ textDecoration: "none", color: "blue.600" }} _active={{ bg: "white" }} as={Link} href="/#faq-section">
                    <VStack align="flex-start" spacing={1} maxW="250px">
                      <Text fontWeight="medium">FAQs</Text>
                      <Text fontSize="xs" color="gray.600" whiteSpace="normal">SwiftChang Frequently Asked Questions</Text>
                    </VStack>
                  </MenuItem>
                </MenuList> 
              </Menu> 

              <nav>
                <HStack spacing={8}>
                  <Button 
                    as={Link}
                    href="/help"
                    variant="ghost"
                    _hover={{ textDecoration: "none" }}
                    sx={{
                      position: "relative",
                      "&::after": {
                        content: '""',
                        position: "absolute",
                        bottom: "0",
                        left: "50%",
                        transform: "translateX(-50%) scaleX(0)",
                        width: "100%",
                        height: "2px",
                        backgroundColor: "currentColor",
                        transition: "transform 0.3s ease",
                      },
                      "&:hover::after": {
                        transform: "translateX(-50%) scaleX(1)",
                      },
                    }}
                  >
                      Help
                  </Button>   
                  <Button 
                      as="a" 
                      href="#download-section" 
                      onClick={handleClick("download")}
                      bg="rgb(20, 20, 20)"
                      color="white"
                      px={3}
                      paddingBottom={5}
                      paddingTop={4}
                      size="sm"
                      borderRadius="full"
                      fontWeight="bold"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      _hover={{ bg: "rgb(10, 10, 10)", transform: "scale(1.05)" }}
                    >   
                      Download
                  </Button>      
                </HStack>
                </nav>  
            </HStack>

            {/* MOBILE HAMBURGER ICON */}
            <IconButton
              display={{ base: "flex", md: "none" }}
              icon={<HamburgerIcon />}
              variant="ghost"
              onClick={onOpen}
              aria-label="Open menu"
            />
          </Flex>

          {/* MOBILE DRAWER MENU */}
          <Drawer isOpen={isOpen} placement="right" onClose={onClose} zIndex="4000">
            <DrawerOverlay />
            <DrawerContent>
              <DrawerCloseButton />
              <DrawerHeader paddingTop={10} >Menu</DrawerHeader>
              <DrawerBody>
                <VStack spacing={4} align="stretch">
                  
                  {/* Products Accordion */}
                  <Accordion allowToggle>
                    <AccordionItem border="none">
                      <AccordionButton>
                        <Box flex="1" textAlign="left" fontWeight="medium">
                          Products
                        </Box>
                        <AccordionIcon />
                      </AccordionButton>
                      <AccordionPanel pb={4}>
                        <VStack align="stretch" spacing={3}>
                          <Link href="/money-transfer#international-transfers" onClick={onClose}>
                            <VStack align="flex-start" spacing={0}>
                              <Text fontWeight="medium">International Transfers</Text>
                              <Text fontSize="xs" color="gray.600">Send money accross border at zero fees</Text>
                            </VStack>
                          </Link>
                          <Link href="/money-transfer#multi-currency" onClick={onClose}>
                            <VStack align="flex-start" spacing={0}>
                              <Text fontWeight="medium">Multi-currency Wallet</Text>
                              <Text fontSize="xs" color="gray.600">Hold and manage multiple currencies</Text>
                            </VStack>
                          </Link>
                          <Link href="/money-transfer#currency-swap" onClick={onClose}>
                            <VStack align="flex-start" spacing={0}>
                              <Text fontWeight="medium">Currency Swap</Text>
                              <Text fontSize="xs" color="gray.600">Exchange currencies instantly</Text>
                            </VStack>
                          </Link>
                        </VStack>
                      </AccordionPanel>
                    </AccordionItem>
                  </Accordion>

                  {/* Company Accordion */}
                  <Accordion allowToggle>
                    <AccordionItem border="none">
                      <AccordionButton>
                        <Box flex="1" textAlign="left" fontWeight="medium">
                          Company
                        </Box>
                        <AccordionIcon />
                      </AccordionButton>
                      <AccordionPanel pb={4}>
                        <VStack align="stretch" spacing={3}>
                          <Link href="/about" onClick={onClose}>
                            <VStack align="flex-start" spacing={0}>
                              <Text fontWeight="medium">About SwiftChang</Text>
                              <Text fontSize="xs" color="gray.600">Learn about our vision & mission</Text>
                            </VStack>
                          </Link>
                          <Link href="/promotions" onClick={onClose}>
                            <VStack align="flex-start" spacing={0}>
                              <Text fontWeight="medium">Promotions</Text>
                              <Text fontSize="xs" color="gray.600">Current offers and deals</Text>
                            </VStack>
                          </Link>
                          <Link href="/community" onClick={onClose}>
                            <VStack align="flex-start" spacing={0}>
                              <Text fontWeight="medium">Refer and Earn</Text>
                              <Text fontSize="xs" color="gray.600">Invite friends and earn rewards for every successful referral</Text>
                            </VStack>
                          </Link>
                          <Link href="/influencer" onClick={onClose}>
                            <VStack align="flex-start" spacing={0}>
                              <Text fontWeight="medium">Become our Influencer</Text>
                              <Text fontSize="xs" color="gray.600">Partner with us to grow and earn as a Swiftchang ambassador</Text>
                            </VStack>
                          </Link>
                          {/*<Link href="#" onClick={onClose}>
                            <VStack align="flex-start" spacing={0}>
                              <Text fontWeight="medium">Careers</Text>
                              <Text fontSize="xs" color="gray.600">Join our growing team</Text>
                            </VStack>
                          </Link> */}
                        </VStack>
                      </AccordionPanel>
                    </AccordionItem>
                  </Accordion>

                  {/* Resources Accordion */}
                  <Accordion allowToggle>
                    <AccordionItem border="none">
                      <AccordionButton>
                        <Box flex="1" textAlign="left" fontWeight="medium">
                          Resources
                        </Box>
                        <AccordionIcon />
                      </AccordionButton>
                      <AccordionPanel pb={4}>
                        <VStack align="stretch" spacing={3}>
                         <Link href="/blog" onClick={onClose}>
                            <VStack align="flex-start" spacing={0}>
                              <Text fontWeight="medium">Blog</Text>
                              <Text fontSize="xs" color="gray.600">Insights, news, and updates from Swiftchang</Text>
                            </VStack>
                          </Link>
                           <Link href="/#faq-section" onClick={onClose}>
                            <VStack align="flex-start" spacing={0}>
                              <Text fontWeight="medium">FAQs</Text>
                              <Text fontSize="xs" color="gray.600">SwiftChang Frequently Asked Questions</Text>
                            </VStack>
                          </Link>
                        </VStack>
                      </AccordionPanel>
                    </AccordionItem>
                  </Accordion>

                  {/* Help Link */}
                  <Button
                    as={Link}
                    href="/help"
                    onClick={onClose}
                    variant="ghost"
                    justifyContent="flex-start"
                  >
                    Help
                  </Button>

                  {/* Download Button */}
                  <Button
                    as="a"
                    href="#download-section"
                    onClick={() => {
                      handleClick("download")();
                      onClose();
                    }}
                    bg="rgb(20, 20, 20)"
                    color="white"
                    borderRadius="full"
                    _hover={{ bg: "rgb(10, 10, 10)" }}
                  >
                    Download
                  </Button>
                </VStack>
              </DrawerBody>
            </DrawerContent>
          </Drawer>
       </Box> ); }
